import { useState } from "react";
import { Backdrop, Card, Checkbox, IconButton, Stack, Tooltip } from "@mui/material";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiInput from "components/SuiInput";

import DeleteIcon from "@mui/icons-material/Delete";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import DownloadIcon from "@mui/icons-material/Download";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import DeselectIcon from "@mui/icons-material/Deselect";

import { removeBackground } from "@imgly/background-removal";

import toast from "react-hot-toast";
import CircularProgress from "@mui/material/CircularProgress";
import { nanoid } from "nanoid";
import { getBase64, dataURLtoFile, matchYoutubeUrl } from "utils/imageHelper";

import api from "services/api";

const ResultImageItem = ({
  projectId,
  item,
  index,
  isSelected,
  handleToggleImage,
  setDeleteVisible,
  setSelectedUrls,
  handleFullScreen,
  handleDownloadUrls,
  setProjectData,
}) => {
  const [loading, setLoading] = useState(false);

  const handleRemoveBackground = (imageUrl) => {
    setLoading(true);
    if (imageUrl) {
      removeBackground(imageUrl)
        .then((blob) => {
          // The result is a blob encoded as PNG. It can be converted to an URL to be used as HTMLImage.src
          //const url = URL.createObjectURL(blob);

          const payload = {
            id: projectId,
            originalUrl: item.src,
            blob: blob,
          };
          handleUpdateResultImage(payload);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          toast.error("Failed to remove background!");
          console.log(err);
        });
    }
  };

  const handleUpdateResultImage = async (payload) => {
    try {
      const file = new File([payload.blob], nanoid() + ".png");

      const uploadedImg = await api.uploads.create([file]).then(({ data }) => {
        const uploaded = data.uploads.map(({ url }) => url);
        return uploaded;
      });
      let url = uploadedImg && uploadedImg.length > 0 ? uploadedImg[0] : "";

      const newPayload = {
        id: payload.id,
        originalUrl: payload.originalUrl,
        newUrl: url,
      };
      const { data } = await api.uwProject.updateAiResultImage(newPayload);

      setProjectData(data.updated);

      toast.success("Successfully update the result image!");
    } catch (err) {
      console.log(err);
      toast.error("Failed to update result image!");
    }
  };

  return (
    <SuiBox sx={{ mb: 1, mx: 1 }}>
      {loading ? (
        <div
          className={`hover-parent  ${
            isSelected ? "uw-selected-img" : "m-[3px]"
          } rounded-md min-h-[120px]`}
          style={{
            position: "relative",
            overflow: "hidden",
          }}
        >
          <img
            src={item.src + `?x-oss-process=image/resize,m_fill,h_256,w_256`}
            alt={"image_" + index}
            style={{ width: "100%", height: "auto", cursor: "pointer" }}
            onClick={(e) => handleToggleImage(item)}
          />{" "}
          <Stack
            spacing={1}
            direction="row"
            alignItems="center"
            sx={{
              position: "absolute",
              top: "40%",
              right: 0,
              left: 0,
              backgroundColor: "#f8f8f8",
              borderRadius: 2,
              mx: 2,
              p: 1,
            }}
            className="shadow-md"
          >
            <CircularProgress size={24} />
            <div>Removing Background</div>
          </Stack>
        </div>
      ) : (
        <div
          className={`hover-parent  ${
            isSelected ? "uw-selected-img" : "m-[3px]"
          } rounded-md min-h-[120px]`}
          style={{
            position: "relative",
            overflow: "hidden",
          }}
        >
          <img
            src={item.src + `?x-oss-process=image/resize,m_fill,h_256,w_256`}
            alt={"image_" + index}
            style={{ width: "100%", height: "auto", cursor: "pointer" }}
            onClick={(e) => handleToggleImage(item)}
          />

          <Checkbox
            checked={isSelected}
            sx={{
              position: "absolute",
              top: 4,
              left: 4,
              width: 24,
              height: 24,
              color: "success",
              backgroundColor: "green",
            }}
            onChange={(e) => handleToggleImage(item)}
          />

          <SuiBox
            className="hover-children"
            sx={{
              position: "absolute",
              top: 4,
              right: 4,
            }}
          >
            <SuiBox display="flex" alignItems="center" justifyContent="flex-end" gap={1}>
              <Tooltip title={"Remove Background"}>
                <IconButton
                  size="small"
                  color="dark"
                  sx={{
                    backgroundColor: "#ffffff",
                    "&:hover": {
                      backgroundColor: "#e3e3e3",
                    },
                  }}
                  onClick={(e) => {
                    handleRemoveBackground(item.src);
                  }}
                >
                  <DeselectIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title={"Delete"}>
                <IconButton
                  size="small"
                  color="dark"
                  sx={{
                    backgroundColor: "#ffffff",
                    "&:hover": {
                      backgroundColor: "#e3e3e3",
                    },
                  }}
                  onClick={(e) => {
                    setDeleteVisible(true);
                    setSelectedUrls([item.src]);
                  }}
                >
                  <DeleteIcon />
                </IconButton>
              </Tooltip>

              <Tooltip title={"Fullscreen"}>
                <IconButton
                  size="small"
                  color="dark"
                  sx={{
                    backgroundColor: "#ffffff",
                    "&:hover": {
                      backgroundColor: "#e3e3e3",
                    },
                  }}
                  onClick={(e) => handleFullScreen(e, item.src)}
                >
                  <FullscreenIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title={"Download"}>
                <IconButton
                  size="small"
                  color="dark"
                  sx={{
                    backgroundColor: "#ffffff",
                    "&:hover": {
                      backgroundColor: "#e3e3e3",
                    },
                  }}
                  onClick={(e) => handleDownloadUrls([item])}
                >
                  <DownloadIcon />
                </IconButton>
              </Tooltip>
            </SuiBox>
          </SuiBox>
        </div>
      )}
    </SuiBox>
  );
};

export default ResultImageItem;
